module.exports = __webpack_public_path__ + "img/bg-scene-2.750342ec.png";